import * as React from "react";
import DatePickerComponent from "../../ui/datepicker/DatePickerComponent";
import {none, Option} from "ts-option";
import {default as DropDownList, DropDownItem} from "../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import DateUtils from "../../../utils/DateUtils";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import moment = require("moment");

interface Props {
	/**
	 * Date.
	 */
	value: Option<moment.Moment>
	/**
	 * On change
	 * @param {Option<moment.Moment>} date
	 */
	onChange: (date: Option<moment.Moment>) => void
	/**
	 * Title
	 */
	title: string
}

interface State {
	menuDropDownVisible: boolean,
	datePickerVisible: boolean
}

export default class DateSelector extends React.PureComponent<Props, State> {

	selectedDateMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
		{id: "l2", label: "Remove"},
	];

	emptyDateMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
	];

	constructor(props: Props) {
		super(props);
		this.state = {menuDropDownVisible: false, datePickerVisible: false};
		this.toggleMenu = this.toggleMenu.bind(this);
		this.onMenuItemSelect = this.onMenuItemSelect.bind(this);
		this.onDateChange = this.onDateChange.bind(this);
	}

	render() {
		return (
			<InfoModule icon={Icon.Calendar}
						title={this.props.title}
						actionIcon={Icon.Overflow}
						onActionIconClick={this.toggleMenu}>
				{this.state.menuDropDownVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({menuDropDownVisible: false})}>
					<DropDownList items={this.props.value.isDefined ? this.selectedDateMenu : this.emptyDateMenu}
								  itemToId={(link: DropDownItem) => link.id}
								  itemToLabel={(link: DropDownItem) => link.label}
								  onSelect={this.onMenuItemSelect}/>
				</DropDownWrapper>}
				{this.state.datePickerVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({datePickerVisible: false})}>
					<DatePickerComponent value={this.props.value} onChange={this.onDateChange} inline/>
				</DropDownWrapper>}
				<span className={"t-body"}>
					{this.props.value.map(v => v.format(DateUtils.DATE_FORMAT)).getOrElse("Not specified")}
					</span>
			</InfoModule>
		)
	}

	toggleMenu() {
		this.setState({menuDropDownVisible: !this.state.menuDropDownVisible})
	}

	onMenuItemSelect(item: DropDownItem) {
		switch (item.id) {
			case "l1":
				this.setState({menuDropDownVisible: false, datePickerVisible: true});
				break;
			case "l2":
				this.setState({menuDropDownVisible: false, datePickerVisible: false}, () => this.props.onChange(none));
				break;

		}
	}

	onDateChange(date: Option<moment.Moment>) {
		this.setState({datePickerVisible: false}, () => this.props.onChange(date))
	}

}